import { html, TemplateElement } from '@webtides/element-js';
import { getClosestParentCustomElementNode } from '@webtides/element-js/src/util/DOMHelper';

export default class TabsElement extends TemplateElement {
    constructor() {
        super({ shadowRender: true });
    }

    properties() {
        return {
            selected: 0,
            tabs: [],
        };
    }

    connected() {
        const tabs = this.children;
        this.tabs = Array.from(tabs).filter(tab => {
            const parent = getClosestParentCustomElementNode(tab);
            return parent === this;
        });
        this.tabTriggers = document.querySelectorAll(`tabs-trigger[tabs-id="${this.id}"]`);
        this.showSelectedTab();

        this.setAttribute('cloak', 'false');
    }

    watch() {
        return {
            selected: (_, selected) => {
                this.dispatch('tab-selected', selected, true);
                this.showSelectedTab();
            },
        };
    }

    showSelectedTab() {
        this.tabs.forEach((tab, index) => {
            tab.style['display'] = index === this.selected ? 'block' : 'none';
            tab.setAttribute('selected', index === this.selected ? 'true' : 'false');
        });

        this.tabTriggers.forEach(tabTrigger => {
            const index = parseInt(tabTrigger.getAttribute('tab'));
            tabTrigger.setAttribute('tab-selected', index === this.selected ? 'true' : 'false');
        });
    }

    select(index) {
        if (index < 0) {
            console.warn(`Tabindex cannot be negative. index was ${index}`);
            index = 0;
        }

        if (index > this.tabs.length - 1) {
            console.warn(`Tabindex cannot be bigger than number of tabs. index was ${index}`);
            index = this.tabs.length - 1;
        }

        this.selected = index;
        this.showSelectedTab();
    }

    template() {
        return html`
            <style>
                :host {
                    display: block;
                    transition: display 0.3s allow-discrete;
                }
            </style>
            <slot></slot>
        `;
    }
}
